/**
 * Генератор уникальных ID для сущностей.
 */
export const generateId = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    
    return `${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 9)}`;
};

/**
 * Генератор числовых ID.
 */
export const generateNumericId = (): number => {
    return Date.now() + Math.floor(Math.random() * 10000);
};
